import Badge, { BadgeOrigin, BadgeProps } from '@mui/material/Badge'
import { PropsWithChildren, memo } from 'react'
import { Theme } from '@mui/material'
import useEmotionStyledComponent from 'hooks/useEmotionStyledComponent'

interface WithIncreasedEmphasisProps {
  display: boolean
}

const anchorOrigin: BadgeOrigin = {
  vertical: 'top',
  horizontal: 'left'
}

const StyledBadge = (props: BadgeProps) => {
  const BadgeStyled = useEmotionStyledComponent<typeof Badge>(
    (theme: Theme) => ({
      root: {
        top: theme.spacing(1)
      }
    }),
    Badge
  )

  return <BadgeStyled {...props} />
}

const WithIncreasedEmphasis = ({
  children,
  display = false
}: PropsWithChildren<WithIncreasedEmphasisProps>) => {
  if (!display) {
    return <>{children}</>
  }

  return (
    <StyledBadge variant="dot" color="secondary" anchorOrigin={anchorOrigin}>
      {children}
    </StyledBadge>
  )
}

export default memo(WithIncreasedEmphasis)
